var _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgL5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7H18.388C18.724 7 19 6.70727 19 6.35091V5.06545C19 4.60091 18.748 4.17455 18.358 3.98364L14.8 2.54545L12.3598 0.474982C11.9984 0.168331 11.5398 0 11.0658 0H7.73415C7.26018 0 6.80161 0.168327 6.4402 0.474971L4.38495 2.21879C4.13225 2.4332 3.83022 2.58146 3.50603 2.65023L2.58499 2.8456C1.66092 3.04162 1 3.85744 1 4.80207V6C1 6.55229 1.44772 7 2 7H3.99995H4.08535C4.29127 6.4174 4.84689 6 5.5 6C6.15311 6 6.70873 6.4174 6.91465 7H13.0854C13.2913 6.4174 13.8469 6 14.5 6C15.1531 6 15.7087 6.4174 15.9146 7H16Z",
    fill: "#00AED9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3.99763H26C28.5111 4.07237 28.7978 5.38059 29.1777 7.44423L29.6606 10.7072C29.8394 11.9152 28.9033 13 27.6822 13H27M1 9L15.0342 12.9624C15.1226 12.9873 15.2141 13 15.3059 13H23V3H22.7208C22.2903 3 21.9082 3.27543 21.7721 3.68377L20.2279 8.31623C20.0918 8.72457 19.7097 9 19.2792 9H1Z",
    stroke: "#00619E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 13,
    r: 2,
    stroke: "#00619E",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13,
    r: 2,
    stroke: "#00619E",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL5);
export default __webpack_public_path__ + "static/media/l5.a634ecf6b495c79779fa3a98caded686.svg";
export { ForwardRef as ReactComponent };